(function(){
  function initCatMenu(){
    var wrap = document.getElementById('bolCatWrap');
    var btn = document.getElementById('bolCatBtn');
    if (!wrap || !btn) return;

    function setOpen(open){
      if (open) {
        wrap.classList.add('is-open');
      } else {
        wrap.classList.remove('is-open');
      }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    btn.addEventListener('click', function(e){
      e.stopPropagation();
      setOpen(!wrap.classList.contains('is-open'));
    });
    var backdrop = wrap.querySelector('.bol-cat-backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', function(){ setOpen(false); });
    }
    document.addEventListener('click', function(e){
      if (!wrap.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && wrap.classList.contains('is-open')) {
        setOpen(false);
        btn.focus();
      }
    });
  }

  function init(){
    initCatMenu();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
